import { useEffect } from 'react'
import { useSignal, batch } from '@preact/signals-react'
import {postSubmit} from '@ui-seeker/utils'

import {commonFiltersValue, isLoadingCommonFilters, isSystemBusy} from '@signals'
import { BACKEND_APIS } from '@constants'
import { isEmpty, keywordsTableData, reloadKeywordsTableData } from "../../@signals";


export default function useKeywordsCrudTableFilters() {

    const isLoading = useSignal(false)

    const handleSubmit = () => {
        isLoading.value = true
        postSubmit(`${BACKEND_APIS.MANAGEMENT}/keywords/context`, commonFiltersValue.value)
            .then(res => {
                if (!res?.length)
                    isEmpty.value = true
                keywordsTableData.value = res
                isLoading.value = false
                isLoadingCommonFilters.value = false
            })
            .catch(() => {
                isLoading.value = false
                isLoadingCommonFilters.value = false
                isSystemBusy.value = true
            })
    }

    useEffect(() => {
        if (isLoadingCommonFilters.value) batch(() => {
            handleSubmit()
        })
    }, [isLoadingCommonFilters.value])

    useEffect(() => {
        if (reloadKeywordsTableData.value) {
            handleSubmit()
            reloadKeywordsTableData.value = false
        }
    }, [reloadKeywordsTableData.value]);

    const updateTableRow = (updateData={}) => keywordsTableData.value = keywordsTableData.value.map(row =>
        row.id === updateData?.id ? updateData : row
    )

    return {
        isLoading: isLoading.value,
        updateTableRow
    }
}